import { useTranslation } from "react-i18next";
import { round } from "lodash";
import convertToRiR from "../../../../utils/converters/convert-intensity";
import {
  getLiftsSetsVolume,
  getPeakValues,
  getWeightedIntensity,
  getWeightedRpe,
  hasRpe,
} from "../../../../utils/actuals";
import { formatMetconResult } from "../../../../utils/metcon";

const ExerciseMetrics = (props) => {
  const { t } = useTranslation("dashboard");
  const {
    exercise,
    fromMetric,
    withWeight,
    units,
    isProgramEditor,
    isRiR,
    intensityMeasure,
  } = props;

  if (isProgramEditor) return null;

  if (exercise.metconResult) {
    return (
      <div className="bg-(--dark-grey) p-4 rounded-xl self-start">
        <p className="p2">{t("calendar.exerciseMetrics.result")}</p>
        <p className="p1 mt-3">{formatMetconResult(exercise.metconResult)}</p>
      </div>
    );
  }

  const { lifts, sets, volume, rpeVolume } = getLiftsSetsVolume(exercise);
  const {
    e1rm: peakE1rm,
    intensity: peakIntensity,
    rpe: peakRpe,
  } = getPeakValues(exercise);
  const avgIntensity = getWeightedIntensity(exercise, volume);
  const avgRpe = getWeightedRpe(exercise, rpeVolume);

  const showRpe = hasRpe(exercise);
  const showRM = exercise.type === "primary" || exercise.type === "secondary";

  return (
    <li className="exercise-metrics-container">
      <div>
        <span className="title">{t("calendar.exerciseMetrics.volume")}</span>
        <span className="value">
          {volume
            ? withWeight(
                round(fromMetric(volume, units, false), 1),
                units,
                false
              )
            : "-"}
        </span>
      </div>
      <div>
        <span className="title">{t("calendar.exerciseMetrics.topE1rm")}</span>
        <span className="value">
          {peakE1rm
            ? withWeight(
                round(fromMetric(peakE1rm, units, false), 1),
                units,
                false
              )
            : "-"}
        </span>
      </div>
      <div>
        <span className="title">{t("calendar.exerciseMetrics.numberOfLifts")}</span>
        <span className="value">{lifts || "-"}</span>
      </div>
      <div>
        <span className="title">{t("calendar.exerciseMetrics.numberOfSets")}</span>
        <span className="value">{sets || "-"}</span>
      </div>
      {!!showRpe && !!avgRpe && (
        <div>
          <span className="title">{t("calendar.exerciseMetrics.avgIntensity", { intensity: intensityMeasure })}</span>
          <span className="value">
            {convertToRiR(round(avgRpe, 1), !isRiR)}
          </span>
        </div>
      )}
      {!!showRpe && !!peakRpe && (
        <div>
          <span className="title">{t("calendar.exerciseMetrics.topIntensity", { intensity: intensityMeasure })}</span>
          <span className="value">{convertToRiR(peakRpe, !isRiR)}</span>
        </div>
      )}
      {!!showRM && !!avgIntensity && (
        <div>
          <span className="title">{t("calendar.exerciseMetrics.avgPercent1rm")}</span>
          <span className="value">{`${round(avgIntensity * 100, 1)}%`}</span>
        </div>
      )}
      {!!showRM && !!peakIntensity && (
        <div>
          <span className="title">{t("calendar.exerciseMetrics.topPercent1rm")}</span>
          <span className="value">{`${round(peakIntensity * 100, 1)}%`}</span>
        </div>
      )}
    </li>
  );
};

export default ExerciseMetrics;
